import * as React from "react";

import { ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { useBreakpoints } from "hooks/use-breakpoints";
import { Subtract } from "utils/interface";

export interface IWithBreakpointsProps {
  breakpointType: ResponsiveBreakpointType;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

/**
 * @deprecated - use CSS media queries when possible, fall back to useBreakpoints
 */
export const withBreakpoints = <P extends IWithBreakpointsProps>(
  WrappedComponent: React.ComponentType<P>
): React.ForwardRefExoticComponent<
  React.PropsWithoutRef<Subtract<P, IWithBreakpointsProps>> & React.RefAttributes<HTMLElement>
> => {
  const WithBreakpoints = React.forwardRef<HTMLElement, Subtract<P, IWithBreakpointsProps>>((props, ref) => {
    const breakpoints = useBreakpoints();

    return <WrappedComponent {...(props as P)} {...breakpoints} ref={ref} />;
  });

  WithBreakpoints.displayName = `WithBreakpoints(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return WithBreakpoints;
};
